export const SidebarFooter = () => (
  <div className="mt-3 border-t border-border pt-3 text-center text-xs text-zinc-600">
    <a
      href="https://nexus-conseil.ch"
      target="_blank"
      rel="noopener noreferrer"
      className="transition-colors hover:text-zinc-400"
    >
      Codé avec ❤️ par NEXUS
    </a>
  </div>
);
